import { Box } from "@mui/material"
import { parseUnits } from "ethers/lib/utils"
import React, { ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import Button from "src/components/Button"
import { enqueueToast } from "src/components/Toastify"
import TransactionSummary from "src/components/TransactionSummary"
import { XFER } from "src/constants"
import { useActiveWeb3React } from "src/hooks"
import { fetchFerroBoostUserDataAsync } from "src/state/xFer"
import { useUserFerroBoost } from "src/state/xFer/hooks"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import useFerroBoostHandlers from "../../hooks/useFerroBoostHandlers"

interface Props {
  remark: ReactNode
  onConfirm: () => void
  value: string
}

const ConfirmStep = ({ onConfirm, remark, value }: Props) => {
  const { t } = useTranslation()
  const { account } = useActiveWeb3React()
  const dispatch = useDispatch()

  const { onApprove } = useFerroBoostHandlers()
  const { boostData } = useUserFerroBoost()

  const { allowance } = boostData

  const isApproveSpending =
    allowance &&
    allowance.gt("0") &&
    allowance.lt(parseUnits(value || "0", XFER.decimals))

  const handleApprove = async () => {
    try {
      await onApprove()
      if (account) {
        dispatch(fetchFerroBoostUserDataAsync(account))
      }
    } catch (e) {
      console.error(e)
      enqueueToast("error", t("xFER is not approved"), t("Transaction Failed"))
    }
  }

  return (
    <Box>
      <Box mb={2} maxWidth="412px">
        {t(
          "You will not be able to withdraw your tokens before the end date. APR figures are estimates provided for your convenience only, and by no means represent guaranteed returns.",
        )}
      </Box>
      <TransactionSummary
        data={[
          {
            label: t("Deposit"),
            amount: formatNumber(value, 2, 6),
            token: XFER,
          },
        ]}
      />
      {remark}
      <Button fullWidth onClick={isApproveSpending ? handleApprove : onConfirm}>
        {isApproveSpending ? t("Approve Spending") : t("Confirm")}
      </Button>
    </Box>
  )
}

export default ConfirmStep
